function cov_iv3awbqha() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/HomeChatFilled.tsx";
  var hash = "476280d84c50aa111a4a2f5b243f38b9a37520b4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/HomeChatFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 56
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "476280d84c50aa111a4a2f5b243f38b9a37520b4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_iv3awbqha = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_iv3awbqha();
var Icon = (cov_iv3awbqha().s[0]++, {
  name: 'home-chat-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 2C3.34315 2 2 3.34315 2 5V18H8L11.75 22L16 18H19C20.6569 18 22 16.6569 22 15V2H5ZM12 6.09863L16 8.7653V13.8005H8V8.7653L12 6.09863Z\" fill=\"currentColor\"/>"
});
export default Icon;